import React, { Component } from 'react';
import Parse from 'parse'
import styled from 'styled-components'
import { inject, observer, PropTypes as MobxPropTypes } from 'mobx-react';
import { withCookies, Cookies } from 'react-cookie';
import { instanceOf } from 'prop-types';
import { withRouter } from "react-router-dom";

import OnboardingLayout from '../components/onboarding/OnboardingLayout';
import MultistepForm from '../components/onboarding/MultistepForm';
import checkmark from '../images/icons/checkmark.svg'
import failuremark from '../images/icons/failuremark.svg'
import spinnerCircle from '../images/icons/spinner-circle.svg'
import { Heading2, Heading3, FullWidthWrapper, TextField, PrimaryButton, NoticeText, ErrorText, Text, Spinner } from '../components/marketing/MarketingStyles';

@inject('userStore')
@observer
class ForgotPassword extends Component {

  constructor(props) {
    super(props)
    this.state = {
      isError: false,
    }
  }

  componentDidMount = () => {
    if(this.props.match.params.token) {
      this.form.select(1)
      Parse.Cloud.run("validateResetPasswordToken", { token: this.props.match.params.token }).then(res => {

        this.form.selectSub(1)
      }).catch(err => {
        this.form.selectSub(2)
        console.error(err)
      })
    }
  }

  setPassword = e => {
    e.preventDefault()
    const data = e.target

    Parse.Cloud.run("useResetPasswordToken", { token: this.props.match.params.token }).then(sessionToken => {
      this.form.selectSub(0)
      return Parse.User.become(sessionToken)
    }).then(res => {
      res.set("password", data.password.value)
      return res.save()
    }).then(() => {
      this.form.selectSub(3)
      Parse.User.logOut()
      Parse.Cloud.run("sendPasswordChangedMail")
    }).catch(err => {
      this.form.selectSub(4)
      console.error(err)
    })
  }

  render() {

    const DefaultSideContent = () => (<img src="https://res.cloudinary.com/theloge/image/upload/w_800/q_auto:good/v1627985015/marketing/features/special_deals.jpg" style={{height: '100%', width: '100%', objectFit: 'cover'}} />)

    const RequestResetForm = ({ selectSub }) => {

      const resetPassword = e => {
        e.preventDefault()
        const data = e.target

        Parse.Cloud.run("generateResetPasswordToken", { mail: data.mail.value }).then(res => {
          selectSub(1)
        }).catch(err => {
          selectSub(2)
          console.error(err)
        })
      }

      const Content = () => (
        <FullWidthWrapper key="wrapper">
          <Heading3>Sie haben Ihr Passwort vergessen?</Heading3>
          <Heading2>Jetzt Passwort zurücksetzen</Heading2>

          <form onSubmit={ resetPassword }>
            <TextField required name="mail" placeholder="E-Mail Adresse" />

            <PrimaryButton
              style={{marginTop: 50}}
              value="Passwort zurücksetzen"
            />

            <NoticeText>Mit dem Klicken des Button bestätigen Sie unsere <a href="/datenschutz">Datenschutzbestimmungen</a> und die Verarbeitung Ihrer Daten.</NoticeText>
          </form>
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } />
      )
    }

    const RequestResetSuccess = ({ selectSub }) => {

      const Content = () => (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <img src={ checkmark } style={{marginBottom: 50}} />
          <Heading2>Anfrage in Bearbeitung</Heading2>
          <SubText>Ihnen wurde eine Bestätigungsmail zugesendet. Prüfen Sie Ihr Postfach, um mit den Prozess fortzufahren.</SubText>
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } />
      )
    }

    const RequestResetError = ({ selectSub }) => {

      const Content = () => (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <img src={ failuremark } style={{marginBottom: 50}} />
          <Heading2>Fehler!</Heading2>
          <SubText>Beim Bearbeiten der Anfrage ist ein Fehler aufgetreten versuchen Sie es erneut.</SubText>
          <PrimaryButton
            style={{marginTop: 50}}
            value="zurück"
            onClick={ () => selectSub(0) }
          />
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } />
      )
    }

    const ResetTokenLoading = ({ selectSub }) => {

      const Content = () => (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <Spinner src={ spinnerCircle } />
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } />
      )
    }

    const ResetTokenPassword = ({ selectSub }) => {

      const Content = () => (
        <FullWidthWrapper key="wrapper">
          <Heading3>Gleich geschafft!</Heading3>
          <Heading2>Setzen Sie Ihr neues Passwort</Heading2>

          <form onSubmit={ e => this.setPassword(e) }>
            <TextField required name="password" type="password" placeholder="Neues Passwort" />

            <PrimaryButton
              style={{marginTop: 50}}
              value="Passwort setzen"
            />

            <NoticeText>Mit dem Klicken des Button bestätigen Sie unsere <a href="/datenschutz">Datenschutzbestimmungen</a> und die Verarbeitung Ihrer Daten.</NoticeText>
          </form>
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } />
      )
    }

    const ResetTokenError = ({ select }) => {

      const Content = () => (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <img src={ failuremark } style={{marginBottom: 50}} />
          <Heading2>Fehler!</Heading2>
          <SubText>Der Token ist nicht gültig. Versuchen Sie es erneut.</SubText>
          <PrimaryButton
            style={{marginTop: 50}}
            value="erneut versuchen"
            onClick={ () => { this.props.history.push("/passwort-vergessen"); select(0) } }
          />
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } />
      )
    }

    const ResetTokenSuccess = ({ selectSub }) => {

      const Content = () => (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <img src={ checkmark } style={{marginBottom: 50}} />
          <Heading2>Passwort erfolgreich zurückgesetzt.</Heading2>
          <PrimaryButton
            style={{marginTop: 50}}
            value="zum Login"
            onClick={ () => this.props.history.push("/login") }
          />
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } />
      )
    }

    const ResetTokenPasswordError = ({ select }) => {

      const Content = () => (
        <FullWidthWrapper style={{ textAlign: 'center' }}>
          <img src={ failuremark } style={{marginBottom: 50}} />
          <Heading2>Fehler!</Heading2>
          <SubText>Ein unbekannter Fehler ist aufgetreten. Versuchen Sie es erneut.</SubText>
          <PrimaryButton
            style={{marginTop: 50}}
            value="erneut versuchen"
            onClick={ () => { this.props.history.push("/passwort-vergessen"); select(0) } }
          />
        </FullWidthWrapper>
      )

      return (
        <OnboardingLayout content={ Content } sideContent={ DefaultSideContent } />
      )
    }

    const steps = [
      {
        title: "RequestReset",
        revisitLocked: true,
        components: [
          () => <RequestResetForm />,
          () => <RequestResetSuccess />,
          () => <RequestResetError />,
        ],
      },
      {
        title: "ResetToken",
        components: [
          () => <ResetTokenLoading />,
          () => <ResetTokenPassword />,
          () => <ResetTokenError />,
          () => <ResetTokenSuccess />,
          () => <ResetTokenPasswordError />,
        ],
      },
    ]

    return (
      <MultistepForm steps={ steps } onRef={ref =>  { this.form = ref } } />
    )
  }
}

const SubText = styled(Text) `
  margin: 0 auto;
`

ForgotPassword.propTypes = {
  userStore: MobxPropTypes.observableObject,
  cookies: instanceOf(Cookies).isRequired
};

export default withRouter(withCookies(ForgotPassword))



// WEBPACK FOOTER //
// /src/pages/ForgotPassword.js